/* eslint-disable no-underscore-dangle */

export function getLocalStorage() {
  return typeof localStorage === 'undefined' ? undefined : localStorage;
}

class Storage {
  get clientID(): string {
    return getLocalStorage()?.getItem('xiemala_chat_client_id') ?? '';
  }

  set clientID(value: string) {
    getLocalStorage()?.setItem('xiemala_chat_client_id', value);
  }

  get grpcHost(): string {
    return getLocalStorage()?.getItem('xiemala_chat_grpc_host') ?? '';
  }

  set grpcHost(value: string) {
    getLocalStorage()?.setItem('xiemala_chat_grpc_host', value);
  }

  get token(): string {
    return getLocalStorage()?.getItem('xiemala_chat_token') ?? '';
  }

  set token(value: string) {
    getLocalStorage()?.setItem('xiemala_chat_token', value);
  }
}

const storage = new Storage();

export default storage;
